import React, { useEffect, useState } from 'react';
import WebApp from '@twa-dev/sdk';
import { FaTelegramPlane } from "react-icons/fa";

interface Product {
  id: number;
  name: string;
  price: number;
  inStock: boolean;
  image: string;
  flavors: string[];
}


const pickupPoint = "тут адерс выдачи";
const contactTelegram = "wizov";
const deliveryFee = 250;

const App = () => {
  const [selectedProductId, setSelectedProductId] = useState<number | null>(null);
  const [products, setProducts] = useState<Product[]>([]);
  const [firstName, setFirstName] = useState<string>("Гость");

  useEffect(() => {
    WebApp.ready();
    const userFirstName = WebApp.initDataUnsafe?.user?.first_name;
    if (userFirstName) {
      setFirstName(userFirstName);
    }
  }, []);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/products`)
      .then((res) => res.json())
      .then((data) => setProducts(data))
      .catch((err) => console.error("Ошибка загрузки продуктов:", err));
  }, []);

  return (
    <div className="min-h-screen py-10 px-4 md:px-0 flex flex-col items-center bg-gradient-to-br from-[#18181b] to-[#23272f]">
      <div className="w-full max-w-3xl">
        <div className="mb-8">
          <h2 className="text-3xl font-bold text-white mb-2 flex items-center gap-2">
            <span className="text-2xl">👋</span>
            Привет, <span className="text-[#90caf9]">{firstName}</span>!
          </h2>
          <p className="text-lg text-[#b0b0b0] font-medium">Каталог табачной продукции:</p>
        </div>
        <div className="grid grid-cols-1 gap-6">
          {products.map((item) => (
            <div
              key={item.id}
              className="relative bg-gradient-to-br from-[#23272f] to-[#18181b] rounded-2xl shadow-lg border border-[#23272f] hover:shadow-2xl transition-shadow duration-300 flex flex-col md:flex-row items-center md:items-start gap-4 p-5"
            >
              <img
                src={item.image}
                alt={`Изображение ${item.name}`}
                className="w-20 h-20 rounded-xl object-cover border-2 border-[#2d3748] shadow"
              />
              <div className="flex-1 w-full">
                <div className="flex items-center justify-between w-full">
                  <h3 className="text-lg font-bold text-white tracking-wide">{item.name}</h3>
                  <span className="text-xl font-semibold text-[#90caf9] flex items-center gap-1">
                    {item.price.toFixed(2)} Kč
                  </span>
                </div>

                {item.flavors?.length > 0 && (
                  <p className="text-sm text-gray-400 mt-1">
                    Вкусы: {item.flavors.join(', ')}
                  </p>
                )}
                <div className="flex items-center gap-2 mt-2">
                  {item.inStock ? (
                    <span className="inline-flex items-center px-2 py-1 rounded-full bg-green-600/20 text-green-400 text-xs font-semibold">
                      <i className="fas fa-check-circle mr-1"></i> В наличии
                    </span>
                  ) : (
                    <span className="inline-flex items-center px-2 py-1 rounded-full bg-red-600/20 text-red-400 text-xs font-semibold">
                      <i className="fas fa-times-circle mr-1"></i> Нет в наличии
                    </span>
                  )}
                </div>
                <div className="mt-4">
                  {item.inStock && (
                    <button
                      onClick={() => setSelectedProductId(selectedProductId === item.id ? null : item.id)}
                      className="group relative inline-flex items-center gap-2 px-5 py-2 rounded-lg bg-gradient-to-r from-[#2e7d32] to-[#388e3c] text-white font-semibold shadow-md hover:from-[#43a047] hover:to-[#66bb6a] transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-[#90caf9]"
                    >
                      <i className="fas fa-shopping-cart"></i>
                      Купить
                      <span className="absolute right-2 top-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-xs text-[#90caf9]">→</span>
                    </button>
                  )}
                </div>
                {selectedProductId === item.id && (
                  <div className="mt-5 bg-[#23272f] border border-[#333] rounded-xl p-4 text-sm text-[#e0e0e0] shadow-inner space-y-2 animate-fadeIn">
                    <div className="flex items-center gap-2">
                      <i className="fas fa-map-marker-alt text-[#90caf9]"></i>
                      <span>Самовывоз: <span className="font-medium">{pickupPoint}</span></span>
                    </div>
                    <div className="flex items-center gap-2">
                      <FaTelegramPlane className="text-[#90caf9]" />
                      <span>
                        Telegram:{" "}
                        <a
                          href={`https://t.me/${contactTelegram}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-[#90caf9] hover:underline"
                        >
                          @{contactTelegram}
                        </a>
                      </span>
                    </div>
                    <div className="flex items-center gap-2">
                      <i className="fas fa-truck text-[#90caf9]"></i>
                      <span>Доставка: <span className="font-medium">{deliveryFee.toFixed(2)}Kč</span></span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      <footer className="mt-16 text-[#6c757d] text-xs text-center">
        <span>by Wizov Dev | @wizov</span>
      </footer>
    </div>
  );
};

export default App;